import { Button, Text } from '@tradener/lumen';

import { ACTIVE_CELL_STYLE, CELL_HEIGHT } from './constants';
import { NineBoxCellProps, NineBoxRatingProps, NineBoxYearProps } from './mockData';
import { NineBoxCellSelectionProps } from './types';

interface NineBoxTableCellProps {
  rating: NineBoxRatingProps;
  ratingLabel: string;
  year: NineBoxYearProps;
  cell: NineBoxCellProps;
  cellStyle: { bg: string; color: string };
  dividerColor: string;
  isLastColumn: boolean;
  shouldShowBottomBorder: boolean;
  isActive: boolean;
  isInteractive: boolean;
  cellOpacity: number;
  onCellSelect: (selection: NineBoxCellSelectionProps) => void;
}

function NineBoxCell({
  rating,
  ratingLabel,
  year,
  cell,
  cellStyle,
  dividerColor,
  isLastColumn,
  shouldShowBottomBorder,
  isActive,
  isInteractive,
  cellOpacity,
  onCellSelect,
}: NineBoxTableCellProps) {
  return (
    <Button
      key={`cell-${rating}-${year}`}
      variant="unstyled"
      px="3"
      py="0"
      borderRadius="0"
      minH={CELL_HEIGHT}
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={cellStyle.bg}
      color={cellStyle.color}
      borderRight={isLastColumn ? undefined : '1px solid'}
      borderBottom={shouldShowBottomBorder ? '1px solid' : undefined}
      borderColor={dividerColor}
      boxShadow={isActive ? ACTIVE_CELL_STYLE : 'none'}
      opacity={cellOpacity}
      transform="translateY(0)"
      transition="box-shadow .2s ease, filter .2s ease, transform .2s ease, opacity .2s ease"
      aria-label={`${ratingLabel} ${year}`}
      aria-pressed={isActive}
      title={`Filtrar por ${ratingLabel} em ${year}`}
      disabled={!isInteractive}
      cursor={isInteractive ? 'pointer' : 'default'}
      _hover={{
        filter: isInteractive && !isActive ? 'brightness(1.06)' : undefined,
        transform: isInteractive ? 'translateY(-1px)' : undefined,
      }}
      _focusVisible={{
        outline: 'none',
      }}
      onClick={() => {
        if (!isInteractive) {
          return;
        }

        onCellSelect({ rating, year });
      }}
    >
      <Text textStyle="caption1-medium" color="currentColor" whiteSpace="nowrap" lineHeight="1">
        {cell.label}
      </Text>
    </Button>
  );
}

export default NineBoxCell;
